import React from 'react'
import 'antd/dist/antd.css';
import { SearchOutlined, EnvironmentOutlined, CheckOutlined, HomeOutlined } from '@ant-design/icons';
import { PAGE_COMPANY } from '../../config'
import Top from '../../components/common/TopBack/index'
import { Layout, Input, Button, Row, Col, Typography, Spin, message, Tooltip, Form, Checkbox } from 'antd';
import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MD5 from 'crypto-js/md5';
import { saveLogin } from '../../utils/api/login'
import logoImg from "../../assets/images/logo.png";
import nameImg from "../../assets/images/name.png";
// import logo from "../../assets/imagesOld/logo1.png";
import { getToken, verificationCode } from '../../utils/api'
const { Content } = Layout;
const { Title } = Typography;
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showHome: false,
        };
        this.industryNews = null
    }

    componentDidMount() {
        console.log(this.props.userLoginInfo);
        this.getToken()
        this.getMsg()
    }
    getToken = async () => {
        let data = await getToken()
        if (data == undefined) { return }
        if (data.code == 0) {
            localStorage.setItem('token', data.data.access_token)
        }
    }
    getMsg = async () => {
        let data = await verificationCode()
    }
    setValue = (n, e) => {
        const value = e.target ? e.target.value : e;
        let obj = {};
        obj[n] = value
        this.setState({
            ...obj
        });
    }

    onFinish = (value) => {

        // value.password = MD5(value.password).toString();
        let opts = value
        opts.password = MD5(value.password).toString()
        opts.verifiableCode = '1'
        opts.verifiableKey = '1'
        if (opts.remember) {
            localStorage.setItem('loginUser', opts.loginUser)
        } else {
            localStorage.setItem('loginUser', '')
        }
        delete opts.remember
        new Promise((resolve, reject) => {
            saveLogin(opts).then(response => {
                if (response == undefined) { return }

                if (response.code === 0) {
                    this.props.saveLoginInfo(response.data);
                    localStorage.setItem('user_time', Date.parse(new Date()))
                    message.success('登录成功')
                    this.props.history.push({ pathname: '/general' })
                } else {
                    message.error(response.message)
                }
                this.setState({
                    loginLoading: false,
                })
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    }
    checkDomain =(rule, value, callback) =>{
        const msgs = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/
        if(!msgs.test(value)){
            callback('密码长度至少8位，至少1个大写字母、1个小写字母、1个数字和1个特殊字符!')
        }else{
            callback();
        }
    }
    render() {
        const size = 368 / 150
        return (
            <Layout style={{ minHeight: '100%', minWidth: '100%', background: '#ccc' }} id='homeId'>
                <Layout >
                    <div className="homeTopBack">
                        <div className="col-lg-3"></div>
                        <div className="col-lg-5">
                            <div className='content'>
                                <img src={logoImg} style={{ width: '50px' }}></img>
                                <img src={nameImg} style={{ width: '220px' }}></img>
                                <Form
                                    style={{ background: '#fff' }}
                                    name="basic"
                                    labelCol={{
                                        span: 8,
                                    }}
                                    wrapperCol={{
                                        span: 16,
                                    }}
                                    initialValues={{
                                        remember: true,
                                    }}
                                    onFinish={this.onFinish}
                                    autoComplete="off"
                                >
                                    <Form.Item
                                        name="username"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入用户名!',
                                            },
                                        ]}
                                    >
                                        <Input placeholder='请输入用户名' />
                                    </Form.Item>

                                    <Form.Item
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入密码!',
                                            },{ validator: this.checkDomain }
                                        ]}
                                    >
                                        <Input.Password placeholder='请输入密码' />
                                    </Form.Item>

                                    {/* <Form.Item
                                    name="remember"
                                    valuePropName="checked"
                                    wrapperCol={{
                                        offset: 8,
                                        span: 16,
                                    }}
                                >
                                    <Checkbox>记住密码</Checkbox>
                                </Form.Item> */}

                                    <Form.Item
                                        wrapperCol={{
                                            offset: 8,
                                            span: 16,
                                        }}
                                    >
                                        <Button htmlType="submit">
                                            登录
                                    </Button>
                                    </Form.Item>
                                </Form>


                            </div> </div>
                        <div className="col-lg-4"></div>
                    </div>
                </Layout>
            </Layout>
        )
    }

}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login))
